var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkplugIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 180 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_27101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.4083 39.0312V38.9771H91.6939V87.0479H132.84L66.5258 206.243L97.4083 206.241V206.189C143.112 205.626 180 168.447 180 122.61C180 76.7733 143.112 39.5947 97.4083 39.0312Z",
    fill: "#07A0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5917 167.212V167.266H88.3061V119.195H47.1601L113.474 0L82.5917 0.00225435V0.0541002C36.8877 0.617636 0 37.7962 0 83.6331C0 129.47 36.8877 166.649 82.5917 167.212Z",
    fill: "#F3A724"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_27101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 206.243,
    display: "inline-block",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkplugIcon);
export default __webpack_public_path__ + "static/media/SparkplugIcon.3eccd1c0fa71a483e31ccfde1ee6ceb5.svg";
export { ForwardRef as ReactComponent };